<template>
  <el-dialog
    :visible="detailDialogVisible"
    title="修改内容"
    width="1200px"
    @close="closeDialog"
  >
    <el-form
      :model="content"
      ref="contentForm"
      :rules="rules"
      label-width="100px"
    >
      <el-form-item label="内容类型：" prop="type">
        <el-select v-model="content.type" placeholder="请选择">
          <el-option
            v-for="item in contentTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="语言类型：" prop="language">
        <el-select v-model="content.language" placeholder="请选择">
          <el-option
            v-for="item in languageList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="内容：" prop="text">
        <editor v-model="content.text" class="editor"></editor>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="toggleDetailDialogVisible(false)">取消</el-button>
      <el-button type="primary" @click="handleSave('contentForm')"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import Editor from 'components/editor';

export default {
  name: 'ContentDetail',
  props: ['content'],
  components: {
    Editor
  },
  data() {
    return {
      rules: {
        type: [{ required: true, message: '内容类型不能为空！' }],
        language: [{ required: true, message: '语言类型不能为空！' }],
        text: [{ required: true, message: '内容不能为空！' }]
      }
    };
  },
  computed: {
    ...mapState('contentSetting', [
      'languageList',
      'contentTypeList',
      'detailDialogVisible'
    ])
  },
  methods: {
    ...mapActions('contentSetting', ['update', 'list']),
    ...mapMutations('contentSetting', ['toggleDetailDialogVisible']),
    closeDialog() {
      this.toggleDetailDialogVisible(false);
      this.$refs['contentForm'].resetFields();
    },
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.update(this.content).then(() => {
            this.$message.success('修改成功！');
            this.toggleDetailDialogVisible(false);
            this.list();
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.editor {
  height: 500px;
}
</style>
